import React from 'react';
import cn from 'classnames';
import styles from './FourthBlock.module.scss';
import { ReactComponent as WaveIcon } from '../../images/wave.svg';

const CARDS = [
  {
    name: 'Светлана Александровна',
    experience: '8&nbsp;лет опыта',
    cite: '&laquo;Главное&nbsp;&mdash; зажечь интерес. Когда ребенок сам хочет понять, почему идет дождь или светит солнце, наука становится игрой&raquo;.',
    tag: 'Естественные\nнауки',
  },
  {
    name: 'Мария Алексеевна',
    experience: '12&nbsp;лет опыта',
    cite: '&laquo;Когда ребенок чувствует силу слов, он&nbsp;учится создавать свой мир&nbsp;&mdash; из&nbsp;мыслей, чувств и&nbsp;фантазий&raquo;.',
    tag: 'Литература',
  },
  {
    name: 'Игорь Сергеевич',
    experience: '9&nbsp;лет опыта',
    cite: '&laquo;Люблю, когда дети спорят, доказывают и&nbsp;ищут решения. Ошибки&nbsp;&mdash; это не&nbsp;промах, а&nbsp;первый шаг к&nbsp;логике и&nbsp;пониманию&raquo;.',
    tag: 'Точные науки\nи&nbsp;логика',
  },
];
export function FourthBlock() {
  return (
    <div className={styles.root}>
      <WaveIcon className={styles.waveImg} />
      <WaveIcon className={styles.waveImg} />
      <div className={styles.content}>
        <h4 className={styles.title}>Ваш ребенок в&nbsp;надежных руках</h4>
        <p className={styles.description}>
          Доверьтесь преподавателям с&nbsp;опытом работы от&nbsp;8&nbsp;лет. Они умеют найти
          индивидуальный подход, заинтересовать ребенка и&nbsp;влюбить его в&nbsp;предмет
        </p>
        <div className={styles.cardsWrapper}>
          {CARDS.map(({ tag, experience, name, cite }, idx) => (
            <div key={name} className={styles.card}>
              <div className={cn(styles.bgImage, styles[`bgImage_${idx}`])}>
                <div className={cn(styles.tag, styles[`tag_${idx}`])} dangerouslySetInnerHTML={{ __html: tag }} />
              </div>
              <div>
                <div className={styles.cardName}>
                  <p className={styles.name} dangerouslySetInnerHTML={{ __html: name }} />
                  <p
                    className={styles.experience}
                    dangerouslySetInnerHTML={{ __html: experience }}
                  />
                </div>
                <p className={styles.cardCite} dangerouslySetInnerHTML={{ __html: cite }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
